module.exports = __webpack_public_path__ + "static/insurance_logo@2x-497dd3f77982b11231105a007bf6d686.png";